import moment from "moment";
import "moment/locale/cs";

import { RouterProvider } from "easy-page-router/react";

import Router from "./Router";

import { UserProvider } from "./User";
import Layout from "./Layout";

moment.locale("cs");

export default function App() {
    return <RouterProvider>
        <UserProvider>
            <Layout>
                <Router />
            </Layout>
        </UserProvider>
    </RouterProvider>;
}
